import React from 'react'

const Footer = () => {
    return (
        <footer className='bck_blue'>
            <div className='footer_disct'>
                Football Team © 2019
            </div>
        </footer>
    );
};

export default Footer

